import finesReimbursements from "./finesReimbursements.component";
import finesReimbursementsUrls from "./finesReimbursements.urls";
import FinesReimbursementsTransforms from "./finesReimbursements.transforms";

const finesReimbursementsModule = angular
  .module("app.components.finesReimbursements", [])
  .component("finesReimbursementsPage", finesReimbursements)
  .service("FinesReimbursementsTransforms", FinesReimbursementsTransforms)
  .config(finesReimbursementsUrls);

export default finesReimbursementsModule;



// WEBPACK FOOTER //
// ./src/pages/finesReimbursements/finesReimbursements.module.js